import React from 'react';
import Container from '../../../containers/master/scholastics/scholasticListContainer';

export default function () {
  return (
    <Container />
  );
}
